/* eslint-disable radix */
import React, { Component } from "react";
import { Stage, Layer, Line, Rect, Circle } from "react-konva";

class ShadowBox extends Component {
  constructor(props) {
    super(props);
    this.lineRef = null;
    this.circleRef = null;
  }

  // if the only prop that changed is initialX or initialY, then we don't need to re-render
  // shouldComponentUpdate(nextProps, nextState) {
  //   return false;
  // }

  handleDrag = (e, fromClick = false) => {
    const { onDrag, circleRadius = 4, width, height } = this.props;
    const halfW = width / 2;
    const halfH = height / 2;

    const x = e.target.x();
    const y = e.target.y();

    let realX = x - halfW;
    let realY = y - halfH;

    // clamp the circle to the box
    if (x < circleRadius) {
      e.target.x(circleRadius);
      realX = -halfW + circleRadius;
    } else if (x > width - circleRadius) {
      e.target.x(width - circleRadius);
      realX = halfW - circleRadius;
    }

    if (y < circleRadius) {
      e.target.y(circleRadius);
      realY = -halfH + circleRadius;
    } else if (y > height - circleRadius) {
      e.target.y(height - circleRadius);
      realY = halfH - circleRadius;
    }

    this.lineRef.points([halfW, halfH, e.target.x(), e.target.y()]);
    onDrag({ x: realX, y: realY });
  };

  handleClick = (e) => {
    const { onDrag, circleRadius = 4, width, height } = this.props;

    const halfW = width / 2;
    const halfH = height / 2;

    const { x, y } = e.target.getRelativePointerPosition();

    const realX = x - halfW;
    const realY = y - halfH;

    this.lineRef.points([halfW, halfH, x, y]);
    this.circleRef.x(x);
    this.circleRef.y(y);
    onDrag({ x: realX, y: realY });
  };

  // if the initialX is 0, set to the center of the square,
  // else, if initialX is negative, set to the left edge of the square,
  // else, if initialX is positive, set to the right edge of the square
  getInitialX = () => {
    const { initialX, width } = this.props;
    const halfW = width / 2;
    
    if (initialX === 0) return halfW;
    return parseInt(initialX) + halfW;
  };

  getInitialY = () => {
    const { initialY, height } = this.props;
    const halfH = height / 2;

    if (initialY === 0) return halfH;
    return parseInt(initialY) + halfH;
  };

  render() {
    const { width, height, circleRadius = 4, color = "red" } = this.props;
    const halfW = width / 2;
    const halfH = height / 2;

    const initialX = this.getInitialX();
    const initialY = this.getInitialY();

    return (
      <Stage width={width} height={height}>
        <Layer>
          <Rect
            onClick={this.handleClick}
            x={0}
            y={0}
            width={width}
            height={height}
            cornerRadius={2}
            fill="white"
            stroke="#E0E0E0"
            strokeWidth="1"
          />
          <Line
            points={[0, halfH, width, halfH]}
            stroke="#F1F1F1"
            strokeWidth={1}
            lineCap="round"
            lineJoin="round"
          />
          <Line
            points={[halfW, 0, halfW, width]}
            stroke="#F1F1F1"
            strokeWidth={1}
            lineCap="round"
            lineJoin="round"
          />
        </Layer>
        <Layer width={60} height={60}>
          <Circle
            draggable
            onDragMove={this.handleDrag}
            x={initialX}
            y={initialY}
            radius={circleRadius}
            fill={color}
            ref={(node) => {
              this.circleRef = node;
            }}
          />
          <Line
            ref={(i) => {
              this.lineRef = i;
            }}
            points={[halfW, halfH, initialX, initialY]}
            stroke={color}
            strokeWidth={2}
          />
        </Layer>
      </Stage>
    );
  }
}

export default ShadowBox;
